export default __webpack_public_path__ + "assets/images/ab46f2730ded539b6cd071125e03e3a5.svg";